import React from "react";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "../ui/select";
import { Input } from "../ui/input";
import { cn } from "../../lib/utils";

export const TRANSFER_REASONS = [
  "Product Stock not available",
  "Pincode not serviceable",
  "Better fulfillment partner available",
  "Other",
];

interface TransferReasonsProps {
  value: string;
  onChange: (value: string) => void;
  required?: boolean;
}

export const TransferReasons: React.FC<TransferReasonsProps> = ({
  value,
  onChange,
  required = true,
}) => {
  const [isOtherSelected, setIsOtherSelected] = React.useState(false);

  const isPredefinedReason = TRANSFER_REASONS.includes(value);

  const showCustomInput = isOtherSelected || (value && !isPredefinedReason);

  const handleValueChange = (selectedValue: string) => {
    if (selectedValue === "Other") {
      setIsOtherSelected(true);
      onChange("");
    } else {
      setIsOtherSelected(false);
      onChange(selectedValue);
    }
  };

  const handleCustomReasonChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange(e.target.value);
  };

  const selectDisplayValue = isPredefinedReason
    ? value
    : showCustomInput
      ? "Other"
      : "";

  return (
    <div className="space-y-2 w-full">
      <Select value={selectDisplayValue} onValueChange={handleValueChange}>
        <SelectTrigger
          id="transfer-reason"
          className="w-full bg-white dark:bg-gray-700 dark:text-gray-200 border-gray-200 dark:border-gray-600 rounded-lg px-4 py-2"
        >
          <SelectValue placeholder="Select a reason for transfer" />
        </SelectTrigger>
        <SelectContent className="dark:bg-gray-800 dark:text-white dark:border-gray-700">
          {TRANSFER_REASONS.map(reason => (
            <SelectItem key={reason} value={reason}>
              {reason}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      {showCustomInput && (
        <Input
          type="text"
          placeholder="Enter custom reason"
          value={value}
          onChange={handleCustomReasonChange}
          className={cn(
            "w-full bg-white dark:bg-gray-700 dark:text-gray-200 border-gray-200 dark:border-gray-600 rounded-lg px-4 py-2 focus:outline-none transition-colors",
            "mt-2",
          )}
        />
      )}
    </div>
  );
};

export default TransferReasons;
